import { render, staticRenderFns } from "./select-many-checkbox.vue?vue&type=template&id=9b726440"
import script from "./select-many-checkbox.vue?vue&type=script&lang=js"
export * from "./select-many-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports